import { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectSiteById,
  selectSitesBySn,
  selectSitesState,
  deleteSite,
  leaveSiteContactship,
  fetchSitesBySn,
} from '../../redux/slices/sitesSlice';
import { autoLogin, selectAuthState } from '../../redux/slices/authSlice';
import { fetchContacts, selectContactsBySiteId, selectContactsState } from '../../redux/slices/contactsSlice';
import { fetchUsers } from '../../redux/slices/usersSlice';
import { RootState } from '../../redux/store';
import SiteForm from './SiteForm';
import ContactsCard from './ContactsCard';
import { styled } from '@material-ui/styles';
import FormDialog from '../../components/FormDialog';
import ConfirmDialog from '../../components/ConfirmDialog';
import { formatDateTime } from '../../utils/helperFuncs';

import {
  fetchConcentrateursBySiteId,
  fetchConcentrateursBySitesSn,
  selectConcentrateursBySiteId,
  selectConcentrateursBySiteSn,
  selectConcentrateurById,
  selectConcentrateursState,
  fetchConcentrateursForSiteSn,
} from '../../redux/slices/concentrateursSlice';

import {
  Paper,
  Typography,
  Button,
  Divider,
  useMediaQuery,
  DialogTitle,
  IconButton,
  Dialog,
  DialogActions,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useMainPageStyles } from '../../styles/muiStyles';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import GroupAddOutlinedIcon from '@material-ui/icons/GroupAddOutlined';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import PeopleAltTwoToneIcon from '@material-ui/icons/PeopleAltTwoTone';
import { Contact, ContactState, SiteState, Equipement, EquipementState, Voie2mesure } from '../../redux/types';
import { selectEquipementsStateSn, fetchEquipementsBySitesSn, selectEquipementsBySiteSn, selectEquipementsState, fetchEquipementsForSiteSn, fetchEquipements, fetchEquipementsBySiteId } from '../../redux/slices/equipementsSlice';
import EquipementsCard from './EquipementsCard';
import { fetchPostes, selectPostesBySiteId, selectPostesState } from '../../redux/slices/postesSlice';
import { selectUsagesState } from '../../redux/slices/usagesSlice';
import { selectQuestionsInstrumsState } from '../../redux/slices/questionsInstrumSlice';
import { fetchVoie2mesures, selectVoie2mesuresState } from '../../redux/slices/voie2mesuresSlice';
import { selectRoomsState } from '../../redux/slices/roomsSlice';

interface ParamTypes {
  siteId: string;
  contactId: string; 
  siteSn: string; 
//  equipements: EquipementState[];
  /*
  sitesWSn: string;    // contient les sites correspondants au SN demandé SiteState[]
  contactsSitesSn: string;*/ //ContactState[];
/*concHardSn: string;
  concTel: string;
  concId: string;
  isMobile: boolean;*/
  /*siteSn: string;
  concentrateurs: string;*/
//  concentrateurs: Array<{ id: string }>;
}

const EquipDetailsPage = () => {
  const classes = useMainPageStyles();
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { siteId, contactId, siteSn /*, sitesWSn, contactsSitesSn*//*, concHardSn, concTel, concId*/ } = useParams<ParamTypes>();
  //console.log("DEBUG siteId: "+siteId+" siteSn: "+siteSn)
  const { user } = useSelector(selectAuthState);
  const siteInState = useSelector((state: RootState) =>
    selectSiteById(state, siteId/*, contactId*/)
  );
  const { sites /*, fetchStatus*/ } = useSelector(
    selectSitesState
  );
//  dispatch(fetchEquipementsBySitesSn(siteSn));

/*TODO: test here dispatch(fetchEquipementsBySiteId(siteId));
//TODO: loop HERE =>  dispatch(fetchEquipementsBySiteId(siteId))
*/
  //dispatch(fetchEquipementsBySiteId(siteId))
  const { equipements, fetchLoading, fetchError, sortBy } = useSelector(
    selectEquipementsState
  );

  const { contacts } = useSelector(
    selectContactsState
  );

/*  const equipements = useSelector((state: RootState) =>
    selectEquipementsState/*BySiteSn(state, siteSn)/
  );
  
  const { fetchLoading, fetchError, sortBy } = useSelector(selectEquipementsState)
*/
/*  useEffect(() => {
    if(!equipements) {
//      dispatch(fetchEquipementsBySitesSn(siteSn));
      dispatch(fetchEquipementsBySiteId(siteId));
    }
  }, []);*/

//  console.log("EqDetPage nb equipements :"+equipements.length)
//  dispatch(fetchConcentrateursForSiteSn(siteSn));

  const { concentrateurs } = useSelector( selectConcentrateursState );
//  concentrateurs.map((c) => console.log("SN site from CONC: "+c.site_id))
  const siteConcentrateurs /*concInState*/ = concentrateurs.filter((c) => Number(c.site_sn) === Number(siteSn))
  /*useSelector((state: RootState) =>
  //  selectConcentrateursBySiteId(state, siteId)
  //  selectConcentrateursBySiteSn(state, siteSn)
    selectConcentrateursBySiteSn(state, siteSn)
  );*/
  console.log("CC: "+concentrateurs.length)// / "+siteConcentrateurs.length)
  console.log("CC siteConc: "+siteConcentrateurs.length)
/*  useEffect(() => {
    dispatch(fetchEquipementsBySiteId(siteId))
    if (equipementsStateSiteSn.length > 0) {
      dispatch(autoLogin());
      dispatch(fetchEquipementsForSiteSn(siteSn));    // CAUSE jwt malformed error ?
      dispatch(fetchEquipementsBySitesSn(siteSn));
      dispatch(fetchConcentrateursForSiteSn(siteSn));    // CAUSE jwt malformed error ?
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipements]);*/
/*  console.log("SN site: "+siteSn)
  console.log("ID site: "+siteId) */
  
/*  console.log("EQUIPEMENTS LENGTH: "+equipements.length)
  const equipementsStateSiteSn = useSelector((state: RootState) =>
    selectEquipementsBySiteSn(state, siteSn)
  );*/
/*  if (!equipements) {
        dispatch(autoLogin());
        dispatch(fetchEquipementsForSiteSn(siteSn));    // CAUSE jwt malformed error ?
        dispatch(fetchEquipementsBySitesSn(siteSn));
        dispatch(fetchConcentrateursForSiteSn(siteSn));    // CAUSE jwt malformed error ?
  }*/

  console.log("Site SN EquipDetailsPage: "+siteSn);
  
  const [filterValue, setFilterValue] = useState('');
  const filteredSortedSites = sites;
  const filteredSortedContacts = contacts;
  const [viewConcentrateurs, setViewConcentrateurs] = useState(false);
  
  console.log("siteInState : " + siteInState+" / Site ID EquipDetailsPage: "+siteId);
  
//  const { postes } = useSelector( selectPostesState );
  const { postes } = useSelector( selectPostesState );/*((state: RootState) => selectPostesBySiteId(state, '100107'));*/
  const { usages } = useSelector(selectUsagesState);
  console.log("Nb USAGES: "+usages?.length)
  const { rooms } = useSelector(selectRoomsState);
  console.log("Nb ROOMS: "+rooms?.length)
  const { questions_instrums } = useSelector(selectQuestionsInstrumsState);
  const { voie2mesures } = useSelector(selectVoie2mesuresState);

//  console.log("selConcbySiteSn : " + /*concInState.*/concentrateurs.length/*.map((c) => c.hardSn)*/);
//  console.log("selEquipState " + equipements + " equipSateSiteSn" + equipementsStateSiteSn/* + " siteEquipements "+siteEquipements.length*/);
//  const {id, id_piece, id_poste, id_questions, id_ref, id_type_usage} = equipements;
//  console.log("nb équipements trouvés pour le site["+siteSn+"]: "+ equipementsStateSiteSn.length);
  const isAdmin = true;

  const handleDeleteSite = () => {
 //   dispatch(deleteSite(id, history));
  };

  const handleLeaveSite = () => {
 //   dispatch(leaveSiteContactship(id, history));
  };

//  const showContactsBtn = () => {
  const showConcentrateursBtn = () => {
    //if (contacts.length < 2) return null;
    return null;
    if (isMobile) {
      return (
        <Button
          color={viewConcentrateurs ? 'secondary' : 'primary'}
          variant="contained"
          onClick={() => setViewConcentrateurs(!viewConcentrateurs)}
          style={{ marginRight: '1em' }}
          className={classes.roundIconButton}
        >
          {viewConcentrateurs ? <ExpandLessIcon /> : <PeopleAltTwoToneIcon />}
        </Button>
      );
    } else {
      return (
        <Button
          color="secondary"
          variant="outlined"
          startIcon={viewConcentrateurs ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          onClick={() => setViewConcentrateurs(!viewConcentrateurs)}
          style={{ marginRight: '1em' }}
        >
          {viewConcentrateurs ? 'Hide Concentrateurs' : 'View Concentrateurs'}
        </Button>
      );
    }
  };

  const leaveSiteBtn = () => {
    if (isAdmin) return null;

    return (
      <ConfirmDialog
        title="Confirm Leave Site"
        contentText="Êtes-vous certain de vouloir quitter l'édition des propriétés du site (=Logement) ?"
        actionBtnText="Quitter le Site"
        triggerBtn={{
          type: isMobile ? 'round' : 'normal',
          text: 'Leave Site',
          icon: ExitToAppOutlinedIcon,
        }}
        actionFunc={handleLeaveSite}
      />
    );
  };

  return (
      <div className={classes.root}>
        <EquipementsCard allConcentrateurs={siteConcentrateurs/*[siteId]*/} postes={postes} usages={usages} 
    questions={questions_instrums} pieces={rooms} voies2mesures={voie2mesures} equipements={equipements}
    concentrateurs={siteConcentrateurs/*siteConcentrateurs*/} /*equipements={equipementsStateSiteSn}*/ siteId={siteId} siteSn={siteSn}
          /*hardSn={"hardSN"*concentrateurs*} tel={"TEL"/*concentrateurs*} modules={[9876,6775,8906]} concId={"concId"/*concentrateurs*}
          date_last_data={new Date()} /*concId={"concID"}
          ts_last_data={new Date()}*/ isMobile={isMobile} />
        </div>
        );
};

export default EquipDetailsPage;
